import { PaymentUtilService } from '@services/payment-util/payment-util.service';
import { MatDialog, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Component, inject } from '@angular/core';
import { CloseBtnComponent } from '@common-components/close-btn/close-btn.component';
import { ButtonComponent } from '@common-components/button/button.component';

@Component({
  selector: 'app-utm-popup',
  standalone: true,
  imports: [
    CloseBtnComponent,
    ButtonComponent
  ],
  templateUrl: './utm-popup.component.html',
  styleUrls: ['./utm-popup.component.scss']
})
export class UtmPopupComponent {

  readonly paymentUtil = inject(PaymentUtilService);
  private dialog = inject(MatDialog);
  public data: any = inject(MAT_DIALOG_DATA);


  activateHundredRs() {
    this.paymentUtil.utmProceedClicked = true;
    this.dialog.closeAll();
    setTimeout(() => {
      window.scrollTo({ top: 1000, behavior: 'smooth' });
    }, 500);
  }

}
